var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircle3 = function SvgCircle3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 132 78"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5F2DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M30.5 35C30 30.5 33.8 20 53 14s30.333-7.833 33.5-8c8.167-.666 19-2.562 33.5 6.5 8.8 5.5 15 16.5 4.5 29.5S89 71.5 69 74.5 22.5 78 10.5 68 3.5 44.5 9 38c2.28-2.695 9.98-11.668 19.778-20M73.5 6c-12.877-10.243-30.892.24-44.722 12M117 22c2 2.667 5.1 9.4 1.5 15-4.5 7-10 11.5-17.5 15S73.5 62.5 54.5 64.5s-37.5-3-44-8S-11.444 37 28.778 18"
  })));
};
export default SvgCircle3;